import React from "react"
import PropTypes from "prop-types"

import Layout from "../components/Layout"
import OpenSourcePage from "../components/OpenSource/OpenSourcePage"
import TitleAndMetaTags from "../components/TitleAndMetaTags"

import { withStyles } from "@material-ui/core/styles"
import createCanonicalUrl from "../utils/createCanonicalUrl"

const styles = {
  root: {
    width: "100%",
  },
}

const OpenSource = ({ location, classes }) => (
  <Layout location={location}>
    <TitleAndMetaTags
      title="Open Source &ndash; DB System NUS"
      canonicalUrl={createCanonicalUrl("/opensource")}
    />

    <div className={classes.root}>
      <OpenSourcePage />
    </div>
  </Layout>
)

OpenSource.propTypes = {
  //data: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(OpenSource)
